module.exports = __webpack_public_path__ + "img/question-visual-tablet.5d8c706f.png";